module.exports = "<img class=\"medium-img\" src=\"" + require("../../../resources/images/github-logo.png") + "\"/><h2>Slides and source available on GitHub</h2><a href=\"https://mike-plummer.github.io/intro-to-kotlin\"><h4>https://mike-plummer.github.io/intro-to-kotlin</h4></a><a href=\"https://www.github.com/mike-plummer/intro-to-kotlin\"><h4>https://www.github.com/mike-plummer/intro-to-kotlin</h4></a>";


//////////////////
// WEBPACK FOOTER
// ./src/slides/00-links/01.pug
// module id = 315
// module chunks = 1